import { IntlShape } from 'react-intl';
import { JobDtoType } from '../../../../../domain/jobs';
import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import OperatorsBulkUpdateFormPresentation from './operators-bulk-update-form-presentation';
import { OperatorsBulkUpdateFormViewModel } from './operators-bulk-update-form.viewmodel';
import { IEventRequestParams } from '../../../../../api/shared.dto';

interface IOperatorsBulkUpdateFormContainerProps {
    intl: IntlShape;
    meetingIds: number[];
    saveBulkCompletedCallback?: (attendeesToUpdate: JobDtoType) => void;
    eventRequestParams: IEventRequestParams;
}

const OperatorsBulkUpdateFormContainer = withViewModel(OperatorsBulkUpdateFormPresentation,
    async (props: IOperatorsBulkUpdateFormContainerProps) => {
        return new OperatorsBulkUpdateFormViewModel(
            props.intl,
            props.meetingIds,
            props.eventRequestParams,
            props.saveBulkCompletedCallback
        );
    }
);

export {
    OperatorsBulkUpdateFormContainer as OperatorsBulkUpdateForm,
    IOperatorsBulkUpdateFormContainerProps,
};
